import { get } from '@/config/fetchApi.js'
import { ENDPOINT_REVIEWS, ENDPOINT_UNITS_REVIEWS } from '@/config/constants.js'
import { queryParam } from '@/config/queryParam.js'

export const getAllReviews = () => get(ENDPOINT_REVIEWS)
export const getAllReviewsByUnit = (unitId) => get(ENDPOINT_REVIEWS + `unit/${unitId}`)
export const getAllReviewsByUnitDepartment = ({ unitId, departmentId, params }) => {
  return get(`${ENDPOINT_REVIEWS}unit/${unitId}` + (departmentId ? `/department/${departmentId}` : '') + queryParam(params))
}
export const getUnitsReviews = () => get(ENDPOINT_UNITS_REVIEWS)
